import { Api } from "../api/Api";
import { LoaderFunctionArgs } from "react-router-dom";
import { loadSpriteSheet, extractAllThumbnails } from "../CadModelAnnotationPage";
import { CadModel } from "../api/Application";
import { fileUrl } from "../api/Url";

export interface CadModelLoaderData {
    models:     CadModel[];
    thumbnails: Map<number, Record<"top" | "side" | "front" | "rear", string>>;
}

export async function cadModelListLoader( { params }: LoaderFunctionArgs ) {
    const [res, sprite] = await Promise.all( [
        Api.cadModelList(),
        loadSpriteSheet(
            fileUrl( "external/cad/spritesheet.png" ),
            fileUrl( "external/cad/spritesheet.json" ),
        ),
    ] );
    if( !res.isOk ) {
        throw new Error( "Could not load CAD models" );
    }
    return { models: res.value, thumbnails: extractAllThumbnails( sprite ) };
}